import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getQuestionFromConfig } from '../../services/authService';
import { decodeId } from '../../utills/idUtils';
import Done from '../../assets/images/done.png'

const Questionnaire = ({ onSubmit, initiator }) => {
    const { encodedId } = useParams();
    const id = decodeId(encodedId)
    const { state } = useAuth();
    const { user } = state;
    const userId = user?.user_id;
    const [isHovered, setIsHovered] = useState(false);
    const [isPressed, setIsPressed] = useState(false);
    const [formData, setFormData] = useState({
        area_of_improvement: null,
        strength: null,
        key_improvement: null
    });
    
    const [questions, setQuestions] = useState({});
    
    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const data = await getQuestionFromConfig();
                setQuestions(data);
            } catch (error) {
                console.error('Error fetching questions:', error);
            }
        };
        
        fetchQuestions();
    }, []);
    
    console.log("initiator", initiator)

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!id) {
            console.error("Error: Missing required ID.");
            return;
        }

        onSubmit(formData, id, userId);
    };


    return (
        <div className="w-full max-w-4xl flex flex-col mx-auto p-4" id="root">
            <div className="text-center mt-4">
                <h1 className="text-3xl font-bold text-blue-900">
                    Thank you for completing the questionnaire
                </h1>

            </div>
            <div className="lg:flex justify-between items-start ">

                <div className="lg:px-16 p-4  w-full">
                    {initiator && <p className="text-blue-900/95 font-medium  my-4 text-left tracking-tight">
                        Could you please take a moment to share your perspective on the following questions?
                        Your responses will greatly assist {initiator} in achieving their goals
                    </p>}
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">
                            {!initiator ? questions.self_strength_wording || 'Your Strengths' :
                                (questions.other_strength_wording || '').replace('{{assessee}}', initiator)}
                        </label>
                        <textarea
                            className="w-full p-2 border border-gray-300 rounded"
                            name="strength"
                            rows="2"
                            value={formData.strength}
                            onChange={handleChange}
                            placeholder="Excellent decision-making skills."
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">
                            {!initiator ? questions.self_area_of_improvement_wording || 'Areas for Improvement' :
                                (questions.other_area_of_improvement_wording || '').replace('{{assessee}}', initiator)}
                        </label>
                        <textarea
                            className="w-full p-2 border border-gray-300 rounded"
                            name="area_of_improvement"
                            rows="2"
                            value={formData.area_of_improvement}
                            onChange={handleChange}
                            placeholder="Needs to improve time management."
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">
                            {!initiator ? questions.self_key_improvement || 'Key Improvements' :
                                (questions.other_key_improvement || '').replace('{{assessee}}', initiator)}
                        </label>
                        <textarea
                            className="w-full p-2 border border-gray-300 rounded"
                            name="key_improvement"
                            rows="2"
                            value={formData.key_improvement}
                            onChange={handleChange}
                            placeholder="Describe any key improvements..."
                        />
                    </div>
                    <button
                        type="submit"
                        onClick={handleSubmit}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => {
                            setIsHovered(false);
                            setIsPressed(false);
                        }}
                        onMouseDown={() => setIsPressed(true)}
                        onMouseUp={() => setIsPressed(false)}
                        className={`
        relative 
        px-8 
        py-3 
        text-white 
        font-semibold 
        rounded-lg 
        overflow-hidden 
        group 
        transition-all 
        duration-300 
        ease-in-out
        transform 
        ${isPressed ? 'scale-95' : 'scale-100'}
        bg-gradient-to-br 
        from-blue-600 
        to-blue-800 
        hover:from-blue-700 
        hover:to-blue-900
        shadow-lg 
        hover:shadow-xl
        active:shadow-md
      `}
                    >
                        {/* Glowing effect */}
                        <span
                            className="
          absolute 
          inset-0 
          bg-white 
          opacity-0 
          group-hover:opacity-10 
          transition-opacity 
          duration-300
        "
                        />


                        <span className="relative z-10 flex items-center">
                            Submit <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`
            w-5 
            h-5 
            ml-2 
            transition-transform 
            duration-300 
            ${isHovered ? 'translate-x-1' : 'translate-x-0'}
          `}
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                                />
                            </svg>
                        </span>

                        {/* 3D effect */}
                        <span
                            className="
          absolute 
          inset-0 
          bg-blue-800 
          opacity-20 
          -translate-y-full 
          group-hover:translate-y-0 
          transition-transform 
          duration-300 
          z-0
        "
                        />
                    </button>
                </div>

            </div>

        </div>
    );
};

export default Questionnaire;
